import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {renderRecentSearches} from 'ferries/Home/components/FerrySearchMask/helperStore';

const RecentQuery = ({query, wrapperClass, onClickQuery, translations}) => {
  const queryClass = classnames(
    'd-flex align-items-center rounded popolar-port-overlay',
    wrapperClass
  );

  return (
    <div
      className={queryClass}
      onClick={() => onClickQuery(query)}
    >
      <div className="bg-snow rounded h-6 w-6 text-muted d-flex align-items-center justify-content-center">
        <i className="icon icon-clock" />
      </div>
      <div className="ml-2">
        {renderRecentSearches(query, translations.trips)}
      </div>
    </div>
  );
};

RecentQuery.propTypes = {
  query: PropTypes.object.isRequired,
  wrapperClass: PropTypes.string.isRequired,
  onClickQuery: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    trips: PropTypes.string.isRequired
  })
};

export default RecentQuery;
